import { ContractTradeType } from "@/types";
import { contractsUIConfig } from "@/utils/Contracts";
import ContractTradeTypeEnum from "@/constants/enums/ContractTradeTypeEnum";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import Text from "@/components/atoms/Text";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";

interface TradeIdentifierProps {
  /** Buy/sell direction. Omit for trades that have none (e.g. auctions): the icon and direction label are dropped. */
  tradeType?: ContractTradeType;
  id: number;
  companyName?: string;
  productName?: string;
  /** Swaps the direction icon for the warning icon. The direction label stays. */
  warning?: boolean;
}

function TradeIdentifier({ tradeType, id, companyName, productName, warning = false }: TradeIdentifierProps) {
  const { t } = useTranslation();
  const isBuy = tradeType === ContractTradeTypeEnum.BUY;
  const iconName = warning ? "yellow-exclamation" : tradeType ? contractsUIConfig(tradeType).tableIconName : undefined;

  return (
    <div className={styles.root}>
      {iconName ? (
        <SVGAsset name={iconName} height={24} width={24} style={{ display: "block", flexShrink: 0 }} />
      ) : (
        // Keeps the id aligned with rows that have an icon
        <span className={styles.iconPlaceholder} aria-hidden="true" />
      )}
      <div className={styles.idStack}>
        <Text display="technical" className={styles.idText}>
          #{id}
        </Text>
        {tradeType && (
          <Text
            display="technical"
            className={styles.directionText}
            style={{ color: isBuy ? "var(--color-buy-primary)" : "var(--color-sell-primary)" }}
          >
            {t(`enumerables:contractTradeType.${tradeType}`)}
          </Text>
        )}
      </div>
      {companyName && (
        <Text strong className={styles.companyName} truncate="end">
          {companyName}
          {productName && (
            <Text span color="tertiary">
              {" "}
              — {productName}
            </Text>
          )}
        </Text>
      )}
    </div>
  );
}

export default TradeIdentifier;
